<app-loading
  [busy]="recording$ | async"
  [text]="'recording cogging torque compensation'"
  [cancelable]="true"
  (cancelLoading)="onCancel()"
  [cancelButtonText]="'ABORT'"
></app-loading>

<h4>Cogging Torque Compensation (CTC)</h4>

<app-loading
  [busy]="false"
  [text]="'recording cogging torque compensation'"
  [cancelable]="true"
  (cancelLoading)="onCancel()"
  [cancelButtonText]="'ABORT'"
></app-loading>

<p>
  Cogging torque compensation is a software feature that suppresses torque ripple of electric motors. Such torque ripple
  is typically present on low-cost motor models and it particularly affects motion precision at low-speed motion. In
  robotic arm applications, cogging torque compensation is a useful method to overcome vibration problems.
</p>

<app-doc-feeling-lucky-link qNew="COGGING" qOld="Cogging+Torque+Compensation" [device]="device">
  For additional information about this feature, please visit our documentation site.
</app-doc-feeling-lucky-link>

@if ((dataValid$ | async) === false) {
  <div class="alert alert-warning shadow-sm mt-3" role="alert">
    <i class="bi-exclamation-triangle-fill me-1"></i>
    The cogging torque compensation data is not available or cannot be read!
  </div>
}

<div class="row align-items-center justify-content-between mt-4 mb-1 gap-3">
  <div class="col-auto me-auto d-flex gap-3">
    <span appMotionPreventedTooltip>
      <button
        *appIsPdoControlMode
        class="btn btn-primary"
        (click)="onStartRecording()"
        [disabled]="isMotionPrevented$ | async"
      >
        START RECORDING
      </button>
    </span>
    <div class="d-inline form-check align-self-center" *appIfExpertMode>
      <input type="checkbox" class="form-check-input" id="skipAutoTuningCheckbox" [(ngModel)]="skipAutoTuning" />
      <label class="form-check-label" for="skipAutoTuningCheckbox">
        Position control was configured and tuned manually
      </label>
    </div>
  </div>

  @if ((dataValid$ | async) === true) {
    <div class="col-auto d-flex gap-3 text-end">
      @if (coggingTorqueCompensationEnabledParameter$ | async; as parameter) {
        <div class="d-inline form-check align-self-center gap-2">
          <input
            type="checkbox"
            class="form-check-input"
            id="enableCoggingTorqueCompensationCheckbox"
            [checked]="parameter.value === 1"
            (click)="parameter.value === 0 ? onEnableCoggingTorqueCompensation() : onDisableCoggingTorqueCompensation()"
          />
          <label class="form-check-label" for="enableCoggingTorqueCompensationCheckbox"> Enable CTC </label>
        </div>
      }
      @if (torqueControllerEnabled$ | async) {
        <button class="btn btn-danger" (click)="onDisableTorqueController()">STOP TESTING</button>
      } @else {
        <span appMotionPreventedTooltip>
          @if (brakeActive$ | async) {
            <button
              class="btn btn-primary"
              [ngbPopover]="popContentEnableTestingButtonBrakeActive"
              placement="bottom"
              triggers="mouseenter:mouseleave"
              (click)="onEnableTorqueController()"
              [disabled]="isMotionPrevented$ | async"
            >
              TEST
            </button>
          } @else {
            <button
              class="btn btn-primary"
              (click)="onEnableTorqueController()"
              [disabled]="isMotionPrevented$ | async"
            >
              TEST
            </button>
          }
        </span>
        <ng-template #popContentEnableTestingButtonBrakeActive>
          <div class="alert alert-warning mb-0 shadow-sm" role="alert">
            <i class="bi-exclamation-triangle-fill me-1"></i>
            Brake will be released when testing is enabled. Please ensure that releasing the brake is safe.
          </div>
        </ng-template>
      }
      <button class="btn btn-outline-danger" (click)="onDeleteData()">DELETE DATA</button>
    </div>
  }
</div>

<div class="text-center">
  <app-cogging-torque-compensation-graph
    [data]="data$ | async"
    [position]="positions?.actual"
    [resolution]="(encoderConfigurationUsedForTorque$ | async)?.resolution"
    [enabled]="(coggingTorqueCompensationEnabledParameter$ | async)?.value === 1"
  >
  </app-cogging-torque-compensation-graph>
</div>
